import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const topSwiper = (() => {

  const fvGallery = (document.getElementById('fvGallery') != null),
        video = document.querySelector('.fvVideo'),
        cpGallery = (document.getElementById('cpGallery') != null);

  if (fvGallery) {
    var fvSwiper = new Swiper('.fvSwiper', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 6000,
        stopOnLastSlide: true,
        disableOnInteraction: false,
        waitForTransition: true,
      },
      pagination: {
        el: "#fvGallery .swiper-pagination",
        type: 'bullets',
        clickable: true,
      },
      allowTouchMove: true,
      followFinger: false,
      on: {
        transitionStart: function(){
          video.pause();
          video.currentTime=0;
        },
        transitionEnd: function(){
          console.log(this.realIndex);
          if (this.realIndex == 2) {
            video.currentTime=0;
            video.play();
            video.addEventListener('ended', (e) => {
              this.slideNext();
            });
          }
        },
      }
    });

  }
  if (cpGallery) {

    var cpSwiper = new Swiper('.cpSwiper', {
      effect: 'slide',
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: true,
      },
      pagination: {
        el: "#cpGallery .swiper-pagination",
        type: 'bullets',
        clickable: true,
      },
      allowTouchMove: true,
      followFinger: false,
    });

  }

})();
export default topSwiper;
